// import React, { useEffect, useState, useMemo } from "react";
// import TemplateNavbar from "../../../shared/TemplateNavbar/TemplateNavbar";
// import BreadCrumb from "../../../shared/BreadCrumb";
// import { useStepType } from "../../../../utils/type";
// import { useStep } from "react-hooks-helper";
// import PanierValidStep from "./steps/PanierValidStep";
// import AdresseLivraison from "./steps/AdresseLivraison";
// import ModePaiement from "./steps/ModePaiement";
// import UseAddOrUpdateOrderForm from "./requestForm/UseAddOrUpdateOrderForm";
// import { useAppSelector } from "../../../../redux/hook";
// import { Color } from "../../../../utils/theme";
// import Swal from "sweetalert2";
// import ConnexionModal from "../../../shared/FrontHeader/modal/ConnexionModal";
// import { useGetVendeurByApiKeyQuery } from "../../../../utils/api/product/product.api";
// import { VendeurApikey } from "../../../../utils/http";
// import { formatCurrency } from "../../../../utils/Utils";

// // ─── Étapes fixes (toujours présentes) ───────────────────────────────────────
// const BASE_STEPS = [
//   { id: "panier-validation", label: "Panier",    Component: PanierValidStep },
//   { id: "address-livraison", label: "Livraison", Component: AdresseLivraison },
// ];

// const PAYMENT_STEP = {
//   id: "mode-paiement",
//   label: "Finaliser",
//   Component: ModePaiement,
// };

// // ─── Helper : le vendeur autorise-t-il le paiement à la livraison ? ──────────
// // Adaptez les noms de champs selon votre modèle Vendeur réel.
// function hasPaymentAtDelivery(vendeur: any): boolean {
//   return !!vendeur?.paiement_livraison; // ex: champ booléen côté API
// }

// // Le vendeur a-t-il au moins un mode de paiement en ligne configuré ?
// function hasOnlinePaymentMethods(vendeur: any): boolean {
//   // Adaptez selon la structure réelle (tableau, booléens séparés, etc.)
//   return !!(
//     vendeur?.mode_paiement_wave ||
//     vendeur?.mode_paiement_orange_money ||
//     vendeur?.mode_paiement_card ||
//     vendeur?.modes_paiement?.length > 0
//   );
// }

// function ValidateCommand() {
//   const { user } = useAppSelector((s) => s?.user);
//   const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
//   const [modalConnexion, setModalConnexion] = useState(false);
//   const { cartItems, totalAmount } = useAppSelector((state) => state.cart);

//   // ─── Calcul dynamique des étapes ────────────────────────────────────────────
//   // On mémoïse pour ne recalculer qu'à chaque changement du vendeur.
//   const steps = useMemo(() => {
//     const skipPaymentStep =
//       hasPaymentAtDelivery(vendeur) || !hasOnlinePaymentMethods(vendeur);

//     return skipPaymentStep ? BASE_STEPS : [...BASE_STEPS, PAYMENT_STEP];
//   }, [vendeur]);

//   // react-hooks-helper reçoit la liste d'étapes courante
//   const {
//     step,
//     navigation: { next, previous },
//     index,
//   }: useStepType = useStep({ initialStep: 0, steps });

//   const { Component, label } = step as typeof BASE_STEPS[0] & { label: string };
//   const isLastStep = index === steps.length - 1;
//   const showPaymentStep = steps.length === 3; // true quand l'étape paiement est incluse

//   const {
//     register,
//     onSubmit,
//     isLoading,
//     errors,
//     handleChangePhone,
//     phone,
//     onChangeAdresse,
//     adresse,
//     setValue,
//   } = UseAddOrUpdateOrderForm(next, previous);

//   // ─── Initialisations setValue ────────────────────────────────────────────────
//   useEffect(() => {
//     if (user?.id) {
//       setValue("telephone", user?.telephone);
//       setValue("adresse", user?.adresse);
//       setValue("user", user?.id);
//       setValue("step", 1);
//     }
//   }, [user]);

//   useEffect(() => {
//     setValue("code_commande", new Date().getTime().toString());
//   }, []);

//   useEffect(() => {
//     const produitVisiteur = cartItems?.map((x) => ({
//       produit: x?.produit?.id || x?.produit,
//       prix: x?.prix,
//       quantite: x?.quantite,
//       variations: x?.variations?.map((v) => v.id),
//     }));

//     setValue("vendeur", cartItems[0]?.vendeur);
//     setValue("produits", produitVisiteur);
//     setValue("montant_total", totalAmount);

//     // Si on saute le paiement, forcer "paiement_livraison" comme mode
//     if (!showPaymentStep) {
//       setValue("mode_de_paiement", "paiement_livraison");
//     }
//   }, [cartItems, showPaymentStep]);

//   const precedent = () => {
//     setValue("step", 1);
//     setValue("mode_de_paiement", "");
//     previous();
//   };

//   // ─── Labels dynamiques pour les tabs ────────────────────────────────────────
//   const tabLabels = steps.map((s) => s.label);

//   // ─── Largeur de la barre de progression ─────────────────────────────────────
//   const progressWidth =
//     steps.length === 2
//       ? ["0%", "100%"][index]       // 2 étapes : 0 → 100
//       : ["0%", "53%", "100%"][index]; // 3 étapes : 0 → 53 → 100

//   return (
//     <div className="landing-page-component">
//       <TemplateNavbar showSearch={false} />
//       <div className="page-content">
//         <div className="container pt-4">
//           {/* BreadCrumb dynamique */}
//           <BreadCrumb
//             pageName="mon panier"
//             secondPage={
//               index === 0 ? "valider mon panier" : step.label ?? "Livraison"
//             }
//           />

//           <div className="validate-command-content pt-5 pb-5">
//             <div className="row row-validate">
//               <div className="col-lg-9 validate-wrapper">
//                 <form onSubmit={onSubmit}>

//                   {/* ── Tabs ─────────────────────────────────────────────── */}
//                   <div className="tabs-wrapper pb-4">
//                     <ul className="tabs-container">
//                       {tabLabels.map((tabLabel, key) => (
//                         <li
//                           key={key}
//                           className={`tab-item it${key} ${
//                             index === key ? "tab-item-active" : ""
//                           } ${isLastStep ? "eas_bg" : ""}`}
//                         >
//                           {key + 1}
//                           <span className="tab-indicator">{tabLabel}</span>
//                         </li>
//                       ))}

//                       <div className="progress validate-progress">
//                         <div
//                           className="progress-bar custom-progress"
//                           role="progressbar"
//                           style={{ width: progressWidth }}
//                           aria-valuenow={parseInt(progressWidth)}
//                           aria-valuemin={0}
//                           aria-valuemax={100}
//                         />
//                       </div>
//                     </ul>
//                   </div>

//                   {/* ── Composant d'étape ────────────────────────────────── */}
//                   <Component
//                     register={register}
//                     errors={errors}
//                     handleChangePhone={handleChangePhone}
//                     phone={phone}
//                     vendeur={vendeur}
//                     onChangeAdresse={onChangeAdresse}
//                     adresse={adresse}
//                   />

//                   {/* ── Boutons de navigation ────────────────────────────── */}
//                   <div className="action-btn-content d-flex justify-content-end align-items-center gap-3 pt-4">
//                     {/* Précédent */}
//                     {index >= 1 && cartItems.length > 0 && (
//                       <button
//                         className="step-action-btn validate-go-back-btn"
//                         type="button"
//                         onClick={precedent}
//                       >
//                         Précédent
//                       </button>
//                     )}

//                     {/* Étape 0 → bouton Suivant simple */}
//                     {index === 0 && cartItems.length > 0 && (
//                       <button
//                         className="step-action-btn parcours-submit-btn"
//                         type="button"
//                         onClick={() => next()}
//                       >
//                         Suivant
//                       </button>
//                     )}

//                     {/* Étape intermédiaire (Livraison quand 3 étapes) → submit pour valider le formulaire */}
//                     {!isLastStep && index >= 1 && cartItems.length > 0 && (
//                       <button
//                         className="step-action-btn parcours-submit-btn"
//                         type="submit"
//                       >
//                         Suivant
//                       </button>
//                     )}

//                     {/* Dernière étape → valider la commande */}
//                     {isLastStep && cartItems.length > 0 && (
//                       <button
//                         className="step-action-btn parcours-submit-btn"
//                         type="submit"
//                         disabled={isLoading}
//                       >
//                         {isLoading ? "Validation ..." : "Valider ma commande"}
//                       </button>
//                     )}
//                   </div>
//                 </form>
//               </div>

//               {/* ── Récapitulatif panier ──────────────────────────────────── */}
//               <div className="col-lg-3 py-2">
//                 <div className="cart-card">
//                   <h1 className="title pb-4">Total du panier</h1>
//                   <div className="separator"></div>
//                   <div className="total d-flex align-items-center justify-content-between pt-3">
//                     <span className="sm-title">TOTAL</span>
//                     <span className="sm-value total">
//                       {formatCurrency(totalAmount, vendeur?.devise)}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <ConnexionModal
//         modalConnexion={modalConnexion}
//         setModalConnexion={setModalConnexion}
//       />
//     </div>
//   );
// }

// export default ValidateCommand;









import React, { useEffect, useState, useMemo } from "react";
import TemplateNavbar from "../../../shared/TemplateNavbar/TemplateNavbar";
import BreadCrumb from "../../../shared/BreadCrumb";
import { useStepType } from "../../../../utils/type";
import { useStep } from "react-hooks-helper";
import PanierValidStep from "./steps/PanierValidStep";
import AdresseLivraison from "./steps/AdresseLivraison";
import ModePaiement from "./steps/ModePaiement";
import UseAddOrUpdateOrderForm from "./requestForm/UseAddOrUpdateOrderForm";
import { useAppSelector } from "../../../../redux/hook";
import ConnexionModal from "../../../shared/FrontHeader/modal/ConnexionModal";
import { useShopVendeur } from "../../../../catalog/useShopDevise";
import { formatCurrency} from "../../../../utils/Utils";

// ─── Étapes de base (toujours présentes) ─────────────────────────────────────
const BASE_STEPS = [
  { id: "panier-validation",  label: "Panier",    Component: PanierValidStep },
  { id: "address-livraison",  label: "Livraison", Component: AdresseLivraison },
];

const PAYMENT_STEP = {
  id: "mode-paiement",
  label: "Finaliser",
  Component: ModePaiement,
};

// ─── Helper : le vendeur a-t-il des modes de paiement en ligne configurés ? ──
// ⚠️ Adaptez les noms de champs selon votre modèle API réel
function hasOnlinePaymentMethods(vendeur: any): boolean {
  return !!(
    vendeur?.mode_paiement_wave         ||
    vendeur?.mode_paiement_orange_money  ||
    vendeur?.mode_paiement_card          ||
    vendeur?.modes_paiement?.length > 0
  );
}

function ValidateCommand() {
  const { user } = useAppSelector((s) => s?.user);
  const vendeur = useShopVendeur();
  const [modalConnexion, setModalConnexion] = useState(false);
  const { cartItems, totalAmount } = useAppSelector((state) => state.cart);

  // ─── Calcul dynamique des étapes selon les modes de paiement ─────────────
  // skipPaymentStep = true  → 2 étapes (Panier + Livraison), CASH forcé
  // skipPaymentStep = false → 3 étapes (Panier + Livraison + Paiement)
  const skipPaymentStep = !hasOnlinePaymentMethods(vendeur);

  const steps = useMemo(() => {
    return skipPaymentStep
      ? BASE_STEPS
      : [...BASE_STEPS, PAYMENT_STEP];
  }, [skipPaymentStep]);

  const {
    step,
    navigation: { next, previous },
    index,
  }: useStepType = useStep({ initialStep: 0, steps });

  const { Component } = step as typeof BASE_STEPS[0];
  const isLastStep    = index === steps.length - 1;

  const {
    register,
    onSubmit,
    isLoading,
    errors,
    handleChangePhone,
    phone,
    onChangeAdresse,
    adresse,
    setValue,
  } = UseAddOrUpdateOrderForm(
    next,
    previous,
    skipPaymentStep, // ← paramètre clé
  );

  // ─── Initialisations ──────────────────────────────────────────────────────
  useEffect(() => {
    register("devise");
  }, [register]);

  useEffect(() => {
    if (vendeur?.devise) {
      setValue("devise", vendeur.devise);
    }
  }, [vendeur?.devise, setValue]);

  useEffect(() => {
    if (user?.id) {
      setValue("telephone", user?.telephone);
      setValue("adresse",   user?.adresse);
      setValue("user",      user?.id);
      setValue("step",      1);
    }
  }, [user]);

  // Ne pas forcer code_commande : le backend génère FACT-AAAA-MM-JJ-[boutique]-XXX
  // (même format que les ventes app vendeur).

  useEffect(() => {
    const produitVisiteur = cartItems?.map((x) => ({
      produit:    x?.produit?.id || x?.produit,
      prix:       x?.prix,
      quantite:   x?.quantite,
      variations: x?.variations?.map((v) => v.id),
    }));

    setValue("vendeur",       cartItems[0]?.vendeur);
    setValue("produits",      produitVisiteur);
    setValue("montant_total", totalAmount);
    if (vendeur?.devise) {
      setValue("devise", vendeur.devise);
    }
  }, [cartItems, totalAmount, vendeur?.devise, setValue]);

  const precedent = () => {
    setValue("step", 1);
    setValue("mode_de_paiement", "");
    previous();
  };

  // ─── Barre de progression dynamique ──────────────────────────────────────
  const progressWidth = steps.length === 2
    ? ["0%", "100%"][index]          // 2 étapes : 0% → 100%
    : ["0%", "53%", "100%"][index];  // 3 étapes : 0% → 53% → 100%

  // ─── Labels breadcrumb ────────────────────────────────────────────────────
  const breadcrumbSecond =
    index === 0 ? "Valider mon panier"
    : index === 1 ? "Livraison"
    : "Finaliser";

  return (
    <div className="landing-page-component">
      <TemplateNavbar showSearch={false} />

      <div className="page-content">
        <div className="container pt-4">
          <BreadCrumb pageName="mon panier" secondPage={breadcrumbSecond} />

          <div className="validate-command-content pt-5 pb-5">
            <div className="row row-validate">

              {/* ── Formulaire ────────────────────────────────────────────── */}
              <div className="col-lg-9 validate-wrapper">
                <form onSubmit={onSubmit}>

                  {/* Tabs dynamiques */}
                  <div className="tabs-wrapper pb-4">
                    <ul className="tabs-container">
                      {steps.map((s, key) => (
                        <li
                          key={s.id}
                          className={`tab-item it${key} ${
                            index === key ? "tab-item-active" : ""
                          } ${isLastStep ? "eas_bg" : ""}`}
                        >
                          {key + 1}
                          <span className="tab-indicator">{s.label}</span>
                        </li>
                      ))}

                      <div className="progress validate-progress">
                        <div
                          className="progress-bar custom-progress"
                          role="progressbar"
                          style={{ width: progressWidth }}
                          aria-valuenow={parseInt(progressWidth)}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        />
                      </div>
                    </ul>
                  </div>

                  {/* Composant de l'étape courante */}
                  <Component
                    register={register}
                    errors={errors}
                    handleChangePhone={handleChangePhone}
                    phone={phone}
                    // vendeur={vendeur}
                    onChangeAdresse={onChangeAdresse}
                    adresse={adresse}
                  />

                  {/* Boutons navigation */}
                  <div className="action-btn-content d-flex justify-content-end align-items-center gap-3 pt-4">

                    {/* Précédent (visible dès étape 2) */}
                    {index >= 1 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn validate-go-back-btn"
                        type="button"
                        onClick={precedent}
                      >
                        Précédent
                      </button>
                    )}

                    {/* Étape 0 → Suivant simple */}
                    {index === 0 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn"
                        type="button"
                        onClick={() => next()}
                      >
                        Suivant
                      </button>
                    )}

                    {/* Étape intermédiaire (Livraison, 3 étapes) → submit */}
                    {!isLastStep && index >= 1 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn"
                        type="submit"
                      >
                        Suivant
                      </button>
                    )}

                    {/* Dernière étape → valider commande */}
                    {isLastStep && cartItems.length > 0 && (
                      <button
                        className="step-action-btn parcours-submit-btn"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? "Validation ..." : "Valider ma commande"}
                      </button>
                    )}
                  </div>
                </form>
              </div>

              {/* ── Récap panier ──────────────────────────────────────────── */}
              <div className="col-lg-3 py-2">
                <div className="cart-card">
                  <h1 className="title pb-4">Total du panier</h1>
                  <div className="separator"></div>
                  <div className="total d-flex align-items-center justify-content-between pt-3">
                    <span className="sm-title">TOTAL</span>
                    <span className="sm-value total">
                      {formatCurrency(totalAmount, vendeur?.devise)}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <ConnexionModal
        modalConnexion={modalConnexion}
        setModalConnexion={setModalConnexion}
      />
    </div>
  );
}

export default ValidateCommand;